// components/integrations/shared/FeatureList.tsx
import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';

interface FeatureListProps {
  features: string[];
  title?: string;
}

export const FeatureList: React.FC<FeatureListProps> = ({ features, title = 'Fonctionnalités incluses' }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-5">
      <h4 className="text-sm font-semibold text-slate-800 mb-3 flex items-center gap-2">
        <Shield size={16} className="text-slate-400" />
        {title}
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {features.map((feature, index) => (
          <div key={index} className="flex items-center gap-2 text-sm text-slate-600">
            <CheckCircle size={14} className="text-green-600" />
            {feature}
          </div>
        ))}
      </div>
    </div>
  );
};